import { Component, OnInit, Input, Output, EventEmitter, Optional, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TaxReturnService } from '../../../../../swaggerServices/api/api';
import { ConfigStateService } from '../../../../app/config/config-state.service';
import { ITaxReturn } from '../../../../app/tax-returns/tax-return/model/i-tax-return';
import { TaxReturnStatus } from '../../../../app/tax-returns/tax-return/model/status';
import { TenantConfigService } from '../../../services/tenant-config.service';
import { TranslocoService} from "@jsverse/transloco";

@Component({
    selector: 'reject-confirmation',
    templateUrl: './reject-confirmation.component.html',
    styleUrls: ['./reject-confirmation.component.scss'],
    standalone: false
})
export class RejectConfirmationComponent implements OnInit {
  taxReturn: ITaxReturn;
  @Output() closed = new EventEmitter();
  @Output() completed = new EventEmitter();
  subscriptions: Subscription[] = [];
  uiConfig: TenantConfigService;
  taxReturnAlias: string;
  private dialogData: { taxReturn: ITaxReturn } = inject(MAT_DIALOG_DATA);
  constructor(
    private config: ConfigStateService,
    private taxReturnService: TaxReturnService,
    private translocoService: TranslocoService,
    @Optional() private dialogRef?: MatDialogRef<RejectConfirmationComponent>
    ) {
      this.taxReturn = this.dialogData.taxReturn;
    }

  ngOnInit() {
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias
        this.translocoService.selectTranslate('tax-return-alias').subscribe(value => this.taxReturnAlias = value);
      })
    );
  }

  processTaxReturn() {
    this.taxReturnService.updateTaxReturnWithTaxpayerRejected(this.taxReturn.id).subscribe(() => {
      this.completed.emit();
    });
  }

  onClose(result: boolean = false) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
      return;
    }
    this.closed.emit();
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
